import React from "react";
import OptionsIcon from "assets/Icon_Table_Action.png";
import { RowOptions } from "components/RowOptions";
import {
  ParentCrudItems,
  useParentCrudMenuState,
} from "components/Category/ParentCrudMenu/ParentCrudMenu";
import { DisableMenuItemData } from "pages/PlatformUsers/PlatformUsers";
import { useDispatch } from "react-redux";
import { Location } from "react-router-dom";

type RowOptionMenuProps = {
  location: Location | undefined;
  data: any;
  menuState: ReturnType<typeof useParentCrudMenuState>;
  selectedIds: any[];
  crudItems: ParentCrudItems<any>;
  idColumn: string;
  visible: string | number | null;
  setVisible: React.Dispatch<React.SetStateAction<string | number | null>>;
  disableMenuItemData?: DisableMenuItemData;
  noPermissionsMenuItems: string[];
  parentSelectedId?: number;
  additionalIdColumns?: any;
};

const RowOptionParentCrudMenu: React.FC<RowOptionMenuProps> = ({
  location,
  data,
  menuState,
  selectedIds,
  crudItems,
  idColumn,
  visible,
  setVisible,
  disableMenuItemData,
  noPermissionsMenuItems,
  parentSelectedId,
  additionalIdColumns,
}) => {
  const [menu, menuActions] = menuState;

  const dispatch = useDispatch();

  const close = () => setVisible(null);

  const handleClick = (e: any) => {
    e.stopPropagation();
    setVisible(idColumn);
  };

  const optionList = crudItems
    .filter(i => !i.notInMenus)
    .map((item, _key) => {
      let bDisabled = false;

      if (
        disableMenuItemData &&
        item.permissionsKey &&
        disableMenuItemData.hasOwnProperty(item.permissionsKey) &&
        data &&
        typeof data === "object" &&
        data.hasOwnProperty(
          disableMenuItemData[item.permissionsKey].fieldName
        ) &&
        data[disableMenuItemData[item.permissionsKey].fieldName] ===
          disableMenuItemData[item.permissionsKey].fieldValue
      ) {
        bDisabled = true;
      }

      const hasPermission = item.permissionsKey
        ? !noPermissionsMenuItems.includes(item.permissionsKey)
        : false;

      if (!hasPermission) {
        bDisabled = true;
      }

      return {
        name:
          typeof item.title === "function"
            ? item.title(selectedIds)
            : item.title,
        onClick: (id: string | number) =>
          menuActions.openMenu(item.menuCode, id, true),
        alternateMenuItemOnClick: item.alternateMenuItemOnClick
          ? (id: number | string) => {
              if (typeof id === "string") {
                item.alternateMenuItemOnClick?.(
                  dispatch,
                  [parseInt(id)],
                  additionalIdColumns
                );
              } else {
                item.alternateMenuItemOnClick?.(
                  dispatch,
                  [id],
                  additionalIdColumns
                );
              }
            }
          : null,
        disabled: bDisabled,
        permissionKey: item.permissionsKey,
      };
    });

  return (
    <>
      <img
        onClick={handleClick}
        src={OptionsIcon}
        alt="Options"
        className="Icon"
      />
      <RowOptions
        id={idColumn}
        visibleOptions={visible}
        close={close}
        optionList={optionList}
        additionalIdColumns={additionalIdColumns}
      />
    </>
  );
};

export default RowOptionParentCrudMenu;
